import React from "react";
import styled from "styled-components";

import Vector from "./vector";

const Box = styled.div`
  width: 130px;

  @media (min-width: 768px) {
    width: 220px;
  }
`;

const Logo = ({ size }) => (
  <Box>
    <a
      href="https://www.natif.ai"
      style={{ display: "block", zIndex: "100", position: "relative" }}
    >
      <Vector />
    </a>
  </Box>
);

export default Logo;
